import { HStack, Stack, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { ProductCaptions } from './components/ProductCaptions';
import { ProductHandlers, ProductHandlersProps } from './components/ProductHandlers';
import { ProductList } from './components/ProductList';
import { SearchTerm } from './components/SearchTerm';
import { GlobalProductContextReceivedData, GlobalProductProvider } from './contexts';

export interface DynamicProductProps {
  product: GlobalProductContextReceivedData['product'];
  infoGetter: GlobalProductContextReceivedData['infoGetter'];
  customButton?: ProductHandlersProps['customButton'];
}

export const DynamicProduct: React.FC<DynamicProductProps> = ({
  infoGetter,
  product,
  customButton,
}) => {
  const isDesktop = useBreakpointValue({ base: false, sm: false, lg: true });
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });
  const isMobile = useBreakpointValue({ base: true, sm: false, lg: false });

  const renderContent = () => {
    if (isDesktop) {
      return (
        <VStack w="full">
          <HStack w="full">
            <Stack w="2/5">
              <SearchTerm />
            </Stack>
          </HStack>
          <ProductHandlers customButton={customButton} />
          <ProductCaptions />
          <ProductList />
        </VStack>
      );
    }

    if (isTablet) {
      return (
        <VStack w="full">
          <HStack w="full">
            <Stack w="2/5">
              <SearchTerm />
            </Stack>
          </HStack>
          <ProductHandlers customButton={customButton} />
          <ProductCaptions />
          <ProductList />
        </VStack>
      );
    }

    return (
      <VStack w="full">
        <HStack w="full">
          <SearchTerm />
        </HStack>
        <ProductHandlers customButton={customButton} />
        <ProductCaptions />
        <ProductList />
      </VStack>
    );
  };

  return (
    <GlobalProductProvider
      isDesktop={isDesktop}
      isTablet={isTablet}
      isMobile={isMobile}
      infoGetter={infoGetter}
      product={product}>
      <Box
        w="full"
        bg={Utils.Responsive.PhoneTablet({ tablet: 'neutral.white', phone: undefined })}
        borderRadius={BoxBorder.heavy}
        p={Utils.Responsive.All({ desktop: 'inset.md', tablet: 'inset.sm', phone: 0 })}>
        {renderContent()}
      </Box>
    </GlobalProductProvider>
  );
};
